import { useMemo, useState } from 'react'
import EstoqueHttp from '../../../../services/api/https/estoque/Estoque.http'
import { errorHandler } from '../../../../services/util/error.service'
import { gerarArquivoExcel } from '../../../../services/util/excel.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  GET_ESTADIA: 'Carregando relatório',
}

const INITIAL_STATE = {
  posicoes: [],
  informacoes: {
    estoques_mais_aparicoes: null,
    mais_antigo: null,
    dias_acumulados: null,
  },
  selectedEmpresa: null,
  pathToRedirect: null,
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
  showModal: false,
  selectedPosicao: null,
  globalFilter: '',
}

export default function useRelatorioEstadia() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers

    return {
      getPosicoesEstoqueFromCompany(tpId, companyId) {
        EstoqueHttp.getPosicoesEstoqueForRelatorioEstadia(tpId, companyId)
          .then(res =>
            setState(prevState => {
              prevState.posicoes = res.filter(i => i.volumes > 0)
              prevState.loadingMessage = LOAD_MESSAGE.NONE

              if (res && res.length) {
                prevState.informacoes.tempo_maximo = Math.max(...res.map(p => p.tempo_decorrido))
                prevState.informacoes.tempo_medio = (
                  res.reduce((prev, curr) => prev + curr.tempo_decorrido, 0) / res.length
                ).toFixed(0)
                prevState.informacoes.posicoes_ocupadas = res.filter(i => i.volumes > 0).length
                prevState.informacoes.total_volumes = res.reduce(
                  (prev, curr) => prev + curr.volumes,
                  0,
                )
              }

              return { ...prevState }
            }),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      //Actions

      onInit(selectedTp) {
        if (selectedTp) {
          setState(prevState => ({
            ...prevState,
            loadingMessage: LOAD_MESSAGE.GET_MOVIMENTACOES,
          }))
        } else {
          setState(prevState => ({ ...prevState, errorMessage: 'Selecione um TP' }))
        }
      },

      onChange(name, value) {
        setState(prevState => {
          prevState[name] = value
          switch (name) {
            case 'selectedEmpresa':
              prevState.loadingMessage = LOAD_MESSAGE.GET_ESTADIA
              prevState.informacoes = { ...INITIAL_STATE.informacoes }
              break
            case 'selectedPosicao':
              prevState.showModal = true
              break
            default:
              break
          }
          return { ...prevState }
        })
      },

      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      onClickPosicao(value) {
        setState(prevState => ({ ...prevState, selectedPosicao: value, showModal: true }))
      },

      onCloseModal() {
        setState(prevState => ({ ...prevState, showModal: false, selectedPosicao: null }))
      },

      onClickGerarExcel(posicoes, selectedEmpresa) {
        const colunas = [['Estoque', 'Posição', 'Data de Entrada', 'Volumes', 'Tempo Decorrido']]
        posicoes.forEach(p => {
          colunas.push([
            p.estoque_name,
            p.posicao_endereco,
            p.data_entrada,
            p.volumes,
            p.tempo_decorrido,
          ])
        })

        gerarArquivoExcel(
          'Relatorio de Estadia',
          colunas,
          `relatorio_estadia_${selectedEmpresa.name}.xlsx`,
        )
      },
      globalFilterChanged(value) {
        setState(prevState => ({ ...prevState, globalFilter: value }))
      },
    }
  }, [])

  return { state, localDispatch }
}
